import React, { Component, useState, Suspense } from 'react'
import { BrowserRouter, Route, Switch, HashRouter } from "react-router-dom";
import Routes from './routes/router';
import { Provider } from 'react-redux';
import Loader from './skins/cbSkin/components/Loader';
//import configureStore from './skins/demoskin1/store'
import Components from './ComponentIndex';

function App(props) {
    var skin=props.skin
    const configureStore = Components[skin+"_ConfigureStore"]
    const store = configureStore(window.__PRELOADED_STATE__);
    delete window.__PRELOADED_STATE__;
    return (
        <>
            <Suspense fallback={<Loader></Loader>}>
                <Provider store={store}>
                    <Routes skin={skin}></Routes>
                </Provider>
            </Suspense>
        </>
    )
}
export default App
